<template>
    <TransitionRoot appear :show="isOpen" as="template">
        <Dialog as="div" @close="closeModal" class="relative z-50">
            <TransitionChild as="template" enter="duration-300 ease-out" enter-from="opacity-0" enter-to="opacity-100"
                leave="duration-200 ease-in" leave-from="opacity-100" leave-to="opacity-0">
                <div class="fixed inset-0 bg-black bg-opacity-25"></div>
            </TransitionChild>

            <div class="fixed inset-0 overflow-y-auto">
                <div class="flex min-h-full items-center justify-center p-4 text-center">
                    <TransitionChild as="template" enter="duration-300 ease-out" enter-from="opacity-0 scale-95"
                        enter-to="opacity-100 scale-100" leave="duration-200 ease-in" leave-from="opacity-100 scale-100"
                        leave-to="opacity-0 scale-95">
                        <DialogPanel
                            class="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                            <DialogTitle as="h3" class="text-lg font-medium leading-6 text-gray-900">
                                <h3 class="text-xl text-center">Font Settings</h3>
                            </DialogTitle>

                            <div class="mt-2">
                                <div class="form-group relative w-full mb-4">
                                    <input placeholder="Search ..." type="text"
                                        class="h-10 rounded-md bg-gray-200 outline-none px-4 w-full !pl-8"
                                        v-model="search_txt" />
                                    <span class="  absolute h-full top-0 left-0 flex w-8 items-center justify-center">
                                        <SearchIcon size="18" stroke-width="1" />
                                    </span>
                                </div>
                                <div class=" w-full h-80 overflow-y-auto  py-4 pr-2  ">
                                    <div v-for="(type, i) in types" :key="type" class="mb-6 pb-3 border-b border-gray-200"
                                        :class="{ '!border-b-0': i == types.length - 1 }">
                                        <p class="mb-2 capitalize">
                                            {{ type }}
                                        </p>
                                        <div class="h-12 w-full rounded-full px-6 flex items-center hover:bg-gray-200 cursor-pointer"
                                            :class="{ 'bg-sky-200': font_selected.name == font.name }"
                                            v-for="font in fonts_search[type]" :key="font.name" @click="chooseFont(font)">
                                            <span class="text-base flex-1 text-left text-black tracking-normal"
                                                :style="{ fontFamily: font.name, fontWeight: font.weight }">{{ font.name
                                                }}</span>
                                            <div class="ml-auto flex items-center gap-1"
                                                v-if="font_selected.name == font.name">
                                                <CircleCheckIcon class="text-hvgreen" stroke-width="1" size="24" />
                                                <span>Selected</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>
<script>
import { SearchIcon, CircleCheckIcon } from "vue-tabler-icons";

import {
    TransitionRoot,
    TransitionChild,
    Dialog,
    DialogPanel,
    DialogTitle,
} from '@headlessui/vue';
export default defineComponent({
    props: {
        font_selected: {
            type: Object
        }
    },
    data() {
        return {
            search_txt: "",
            isOpen: false,
            fonts: {
                classic: [
                    { name: "Arvo", weight: 400 },
                    { name: "Bitter", weight: 400 },
                    { name: "Calistoga", weight: 400 },
                    { name: "Crimson Text", weight: 400 },
                    { name: "EB Garamond", weight: 400 },
                    { name: "IBM Plex Serif", weight: 500 },
                    { name: "Libre Baskerville", weight: 400 },
                    { name: "Lora", weight: 400 },
                    { name: "Merriweather", weight: 400 },
                    { name: "Noto Serif", weight: 400 },
                    { name: "Playfair Display", weight: 400 },
                    { name: "PT Serif", weight: 400 },
                    { name: "Roboto Slab", weight: 400 },
                    { name: "Source Serif Pro", weight: 400 },
                    { name: "Zilla Slab", weight: 400 },
                ],
                mordern: [
                    { name: "Barlow", weight: 400 },
                    { name: "Capriola", weight: 400 },
                    { name: "DM Sans", weight: 500 },
                    { name: "IBM Plex Sans", weight: 400 },
                    { name: "Gothic A1", weight: 600 },
                    { name: "Inter", weight: 400 },
                    { name: "Karla", weight: 700 },
                    { name: "Lato", weight: 400 },
                    { name: "Montserrat", weight: 400 },
                    { name: "Oswald", weight: 400 },
                    { name: "Poppins", weight: 400 },
                    { name: "Quicksand", weight: 500 },
                    { name: "Raleway", weight: 400 },
                    { name: "Roboto", weight: 400 },
                    { name: "Rubik", weight: 400 },
                    { name: "Work Sans", weight: 400 },
                ],
                unique: [
                    { name: "Bebas Neue", weight: 400 },
                    { name: "Courgette", weight: 400 },
                    { name: "Fredoka One", weight: 400 },
                    { name: "Hepta Slab", weight: 400 },
                    { name: "Kite One", weight: 400 },
                    { name: "Nanum Pen Script", weight: 400 },
                    { name: "Nova Round", weight: 400 },
                    { name: "Pacifico", weight: 400 },
                    { name: "Rock Salt", weight: 400 },
                    { name: "Space Mono", weight: 400 },
                    { name: "Special Elite", weight: 400 },
                    { name: "Marck Script", weight: 400 },
                    { name: "Shrikhand", weight: 400 },
                    { name: "Lobster", weight: 400 },
                    { name: "Press Start 2P", weight: 400 },
                    { name: "Rubik Wet Paint", weight: 400 },
                ]
            }
        }
    },
    components: {
        TransitionRoot,
        TransitionChild,
        Dialog,
        DialogPanel,
        DialogTitle,
        SearchIcon, CircleCheckIcon
    },
    computed: {
        types() {
            return Object.keys(this.fonts)
        },
        fonts_search() {
            if (!this.search_txt) {
                return this.fonts;
            }
            var data = {};
            for (let j = 0; j < this.types.length; j++) {
                if (!data[this.types[j]]) {
                    data[this.types[j]] = [];
                }
                for (let i = 0; i < this.fonts[this.types[j]].length; i++) {
                    const element = this.fonts[this.types[j]][i];
                    if (element.name.toLowerCase().includes(this.search_txt)) {
                        data[this.types[j]].push(element);
                    }
                }
            }
            return data;
        },
    },
    methods: {
        closeModal() {
            this.isOpen = false;
        },
        openModal() {
            this.isOpen = true;
        },
        chooseFont(font) {
            this.$emit("changeFont", font);
            this.isOpen = false
        }
    }
})
</script>